import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import compose from 'recompose/compose';
import { API_GET_NEWS, API_GET_NEWS_MORE, apiGetNewsMore, } from '../../actions/NewsActions';
import { propArrayShape, propBool, propFunc, } from '../../helpers/custom-prop-types';
import { isLoadingApis } from '../../helpers/fetch';
import Layout from '../Layout';
import AuthenticationHoc from '../System/AuthenticationHoc';
import SubmitButton from '../Ui/Button/SubmitButton';
import { ProcessLoader } from '../Ui/Loading';
const News = ({ hasMore, isFirstLoading, isLoading, list, loadViewMore }) => (_jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsxs("div", Object.assign({ className: 'l-container l-contents' }, { children: [_jsx("div", Object.assign({ className: 'l-container-10' }, { children: _jsx("div", Object.assign({ className: 'content-box' }, { children: _jsx("h3", { children: "\u304A\u77E5\u3089\u305B" }) })) })), isFirstLoading ? (_jsx("div", Object.assign({ className: 'l-container-12 load-container' }, { children: _jsx(ProcessLoader, {}) }))) : (_jsx("div", Object.assign({ className: 'l-container-9' }, { children: _jsxs("div", Object.assign({ className: 'news-archive' }, { children: [list.map((news) => (_jsxs("dl", { children: [_jsx("dt", { children: _jsx("time", { children: news.createdAt }) }), _jsxs("dd", { children: [news.action && _jsx(Link, Object.assign({ to: news.action }, { children: news.content })), !news.action && news.content] })] }, news.id))), hasMore && (_jsx("aside", { children: _jsx("div", Object.assign({ className: 'more-menu' }, { children: _jsx(SubmitButton, { isDisabled: isLoading, isLoading: isLoading, onClick: () => loadViewMore(list), text: 'View more' }) })) }))] })) })))] })) })));
News.propTypes = {
    hasMore: propBool().isRequired,
    isFirstLoading: propBool().isRequired,
    isLoading: propBool().isRequired,
    list: propArrayShape().isRequired,
    loadViewMore: propFunc().isRequired,
};
const mapStateToProps = ({ fetch, news }) => ({
    hasMore: news.hasMore,
    isFirstLoading: isLoadingApis(fetch, API_GET_NEWS),
    isLoading: isLoadingApis(fetch, API_GET_NEWS_MORE),
    list: news.list,
});
const mapDispatchToProps = (dispatch) => ({
    loadViewMore: (list) => dispatch(apiGetNewsMore(list)),
});
const enhance = compose(AuthenticationHoc({ isMember: true }), connect(mapStateToProps, mapDispatchToProps));
export default enhance(News);
